import axios from 'axios';
import { BASE_URL } from "../config-global.jsx";
import { setSession } from "@/utils/auth.js";
import { handleError } from "@/services/errorHandler.js";
import { AnalyticsService } from "@/services/analytics.js";
import { AUTH_BASE_PATH } from '@/consts/index.js'
import { clearDiscoverySessionCache } from "@/pages/dashboard/intelligence/discovery/_lib/sessionCache.js";

const axiosInstance = axios.create({ baseURL: BASE_URL });

export const AUTH_HEADER_KEY = "jwt"
export const ACCOUNT_HEADER_KEY = "x-account-id"
export const SPACE_HEADER_KEY = "x-space-id"

export const setAxiosAuth = (accessToken) => {
    axiosInstance.defaults.headers.common[AUTH_HEADER_KEY] = accessToken
}

export const setAxiosAccountContext = (accountId) => {
    axiosInstance.defaults.headers.common[ACCOUNT_HEADER_KEY] = accountId
}

export const setAxiosSpaceContext = (spaceId) => {
    axiosInstance.defaults.headers.common[SPACE_HEADER_KEY] = spaceId
}

export const removeAxiosAuth = () => {
    delete axiosInstance.defaults.headers.common[AUTH_HEADER_KEY];
}

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        // in case we get 401 from the server, we logout the user completely with the basic default alert message (except for the case of wrong credentials which mean the user try to login with wrong credentials, we want to handle it differently and not redirect him)
        if (error.response?.status === 401 && error.response?.data?.name !== 'wrong-credentials' && error.response?.data?.name !== 'shareable-report-wrong-credentials') {
            // Report only what identifies the failure. error.response also carries `config` (with the
            // request body: e.g. an API key the user just typed into a connect dialog) and `request`,
            // and handleError sends whatever it gets to PostHog.
            handleError({
                status: error.response.status,
                data: error.response.data,
                method: error.config?.method,
                url: error.config?.url,
            })
            // This is a logout path too — reset analytics so the expired user's
            // identity doesn't linger on the /auth page (mis-attributing events +
            // session recordings) until the next login. Mirrors logout().
            AnalyticsService.clearSessions()
            clearDiscoverySessionCache()
            setSession()
            alert('Unauthenticated, Please log in again')
            window.location.href = window.location.origin + AUTH_BASE_PATH
            return
        }
        return Promise.reject((error.response && error.response.data) || 'Something went wrong')
    }
);




export default axiosInstance;
